"use strict";
class OptionAttachedInputsComponent {
  constructor(options = {}) {
    this.wrapperField = options.wrapperField;
    this.controllerFieldSelector = options.controllerFieldSelector;
    this.dependentInputSelector = options.dependentInputSelector;
    this.controllerSelector = this.wrapperField.find(
      this.controllerFieldSelector
    );
    this._bindEvent();
    this._run();
  }
  _run() {
    this.controllerSelector.each((idx, el) => {
      const $field = $(el);
      const enabled = $field.is(":checked");
      $field.parents("div.js-collection-input").find(this.dependentInputSelector).prop("disabled", !enabled);
    });
  }
  _bindEvent() {
    this.controllerSelector.on("change", () => {
      this._run();
    });
  }
}
const CHOICE_COLLECTIONS = ".js-check-box-collection, .js-radio-button-collection";
function isMandatoryQuestion($question) {
  return $question.children(".questionnaire-question").find(".label-required").length > 0;
}
function isHiddenByCondition($question) {
  const wrapper = $question.closest(".answer.question[data-question-id]").get(0);
  return Boolean(wrapper) && wrapper.style.display === "none";
}
function isQuestionAnswered($question) {
  const $matrix = $question.find("table").find(CHOICE_COLLECTIONS);
  if ($matrix.length) {
    return $matrix.toArray().every((row) => $(row).find("input:checked").length > 0);
  }
  if ($question.find(".js-sortable-check-box-collection").length) {
    return true;
  }
  if ($question.find(CHOICE_COLLECTIONS).length) {
    return $question.find("input[type='checkbox']:checked, input[type='radio']:checked").length > 0;
  }
  if ($question.find("[data-active-uploads]").length) {
    return $question.find("[data-active-uploads] [data-filename]").length > 0;
  }
  return $question.find("input[type='text'], textarea").toArray().some((input) => input.value.trim() !== "");
}
function questionErrorMessage($question) {
  return $question.find(CHOICE_COLLECTIONS).length ? "Choix s\xE9lectionn\xE9s doit \xEAtre rempli(e)" : "doit \xEAtre rempli(e)";
}
function validateQuestionnaireForm(form) {
  const $form = $(form);
  let valid = true;
  $form.find(".answer-questionnaire__question").each((idx, el) => {
    const $question = $(el);
    if (!isMandatoryQuestion($question) || isHiddenByCondition($question)) {
      return;
    }
    const $label = $question.children(".questionnaire-question");
    if (isQuestionAnswered($question)) {
      removeError($label);
    } else {
      showError($label, questionErrorMessage($question));
      valid = false;
    }
  });
  let tos = $form.find("input#questionnaire_tos_agreement");
  if (tos.length && !tos.is(":checked")) {
    showError(tos.parent(), "doit \xEAtre accept\xE9(e)");
    valid = false;
  }
  if (!valid) {
    var alert = $(".flash.callout.alert");
    if (!alert.length) {
      $("#content").prepend(
        `<div class="flash callout alert" role="alert" aria-atomic="true" data-closable="" tabindex="0">Votre r\xE9ponse \xE0 l'enqu\xEAte comporte des erreurs.<button name="button" type="button" class="close-button" data-close="" aria-label="Rejeter la notification"><span aria-hidden="true">\xD7</span></button>&nbsp;</div>`
      );
    } else if (alert.attr("style")) {
      alert.removeAttr("style");
    }
  }
  return valid;
}
function reenableSubmitButtons(form) {
  const $buttons = $(form).find("[type='submit'][data-disable]:enabled");
  setTimeout(() => {
    $buttons.prop("disabled", false);
  }, 50);
}
$(document).on("submit", "form", (event) => {
  if (!validateQuestionnaireForm(event.currentTarget)) {
    event.preventDefault();
    reenableSubmitButtons(event.currentTarget);
  }
  window.exitUrl = event.currentTarget.action;
});
$(document).on("change input", ".answer-questionnaire__question input, .answer-questionnaire__question textarea", (event) => {
  const $question = $(event.target).closest(".answer-questionnaire__question");
  if (isMandatoryQuestion($question) && isQuestionAnswered($question)) {
    removeError($question.children(".questionnaire-question"));
  }
});
$(document).on("change", "input#questionnaire_tos_agreement", (event) => {
  if ($(event.target).is(":checked")) {
    removeError($(event.target).parent());
  }
});
$(document).on("confirm", 'form [type="submit"][data-confirm]', (event) => {
  const form = $(event.target).closest("form").get(0);
  if (form && !validateQuestionnaireForm(form)) {
    event.preventDefault();
  }
});
function showError(label, msg) {
  $(label).addClass("is-invalid-label");
  $(label).parent().children("[role=alert]").remove();
  $(label).parent().append(
    '<small class="form-error is-visible" role="alert">' + msg + "</small>"
  );
}
function removeError(label) {
  $(label).removeClass("is-invalid-label");
  $(label).parent().children("[role=alert]").remove();
}
export default function createOptionAttachedInputs(options) {
  return new OptionAttachedInputsComponent(options);
}
